import { Interceptor } from "@core/api/interceptors/interceptor";
import { IdentityStatus } from "@domain/user/user";
import { UserStatusManager } from "@domain/user/user-status-manager";
import { isNotNil } from "@utils/assert";
import { AxiosResponse } from "axios";

export const getIdentityStatusInterceptor: (
	userStatusManager: UserStatusManager,
) => Interceptor<AxiosResponse> = userStatusManager => ({
	onFulfilled: async (response: AxiosResponse) => {
		const identityStatusHeaderValue: string | undefined = response.headers["x-pt-identity-status"];
		if (isNotNil(identityStatusHeaderValue)) {
			const identityStatus = IdentityStatus[identityStatusHeaderValue as keyof typeof IdentityStatus];
			if (isNotNil(identityStatus)) {
				userStatusManager.updateIdentityStatus(identityStatus);
			}
		}
		return response;
	},
});
